import styled from 'styled-components'
import moment from 'moment'
import Moment from 'react-moment'
import { useTranslation } from 'react-i18next'
import { colors, fontWeights } from '@/styles'

const StampContainer = styled.span`
  font-weight: ${fontWeights.regular};
  font-size: 12px;
  color: ${colors.grey56};
  font-family: Inter;
  width: 100%;
  display: flex;
  justify-content: center;
  margin: 12px 0;
`

const TopStamp = ({ date }) => {
  const { t } = useTranslation()
  const timestampYear = moment(date).year()
  const calendarStrings = {
    sameDay: `[${t('b.chat.view.today.text', 'Today')}]`,
    lastDay: `[${t('b.chat.view.yesterday.text', 'Yesterday')}]`,
    lastWeek: 'MMM DD',
    sameElse: now => {
      return timestampYear === now.year() ? 'MMM DD' : 'MMM DD, YYYY'
    }
  }
  return (
    <StampContainer>
      <Moment calendar={calendarStrings}>{`${date}-0000`}</Moment>
    </StampContainer>
  )
}

export default TopStamp
